import React from 'react'
import { Modal, Button, Card, Icon, Tooltip, Alert } from 'antd'
import { ImagePreview } from '../../../../../components'

const ImageHistoryModal = ({ visible, history, onCancel, onSelect }) => {
  const handleSelectImage = image => {
    Modal.confirm({
      title: 'Restore this version?',
      content:
        'This will replace your current shot image with this historical version.',
      okText: 'Yes, Restore',
      cancelText: 'Cancel',
      centered: true,
      icon: <Icon type="exclamation-circle" />,
      onOk() {
        onSelect(image.url)
      }
    })
  }

  return (
    <Modal
      title={
        <span style={{ fontSize: 18, fontWeight: 600 }}>
          Version History{' '}
          <span style={{ color: '#8c8c8c', fontSize: 14, fontWeight: 400 }}>
            ({history.length})
          </span>
        </span>
      }
      visible={visible}
      centered
      onCancel={onCancel}
      footer={null}
      width={900}
      bodyStyle={{
        padding: '24px',
        background: '#f5f7fa',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}
    >
      <Alert
        message="Restore Previous Versions"
        description="Browse through your previously generated images. Click 'Restore' to revert the shot to a specific historical version."
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
          gap: '24px'
        }}
      >
        {history
          .slice()
          .reverse()
          .map((item, index) => (
            <Card
              key={index}
              hoverable
              style={{
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                overflow: 'hidden',
                transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
              bodyStyle={{ padding: '12px 16px' }}
              cover={
                <div
                  style={{
                    height: 160,
                    background: '#f0f2f5',
                    overflow: 'hidden',
                    position: 'relative'
                  }}
                >
                  <ImagePreview
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                    src={item.url}
                    alt={`History ${index}`}
                  />
                </div>
              }
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span
                    style={{
                      fontSize: '12px',
                      color: '#8c8c8c',
                      fontWeight: 500
                    }}
                  >
                    {item.timestamp
                      ? new Date(item.timestamp).toLocaleDateString()
                      : `Version ${history.length - index}`}
                  </span>
                  {item.timestamp && (
                    <span style={{ fontSize: '10px', color: '#bfbfbf' }}>
                      {new Date(item.timestamp).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  )}
                </div>

                <Button
                  type="primary"
                  ghost
                  icon="rollback"
                  size="small"
                  onClick={() => handleSelectImage(item)}
                >
                  Restore
                </Button>
              </div>
            </Card>
          ))}
      </div>
    </Modal>
  )
}

export default ImageHistoryModal
